<template>

    <div class="cookie__popup__holder">
        <div class="cookie__popup__content">
            <p>
                This website uses cookies to ensure you get the best experience on our website.
            </p>
            <div class="cookie__buttons">
                <button class="general-button" @click="acceptCookies">
                    Accept
                </button>
                <button class="general-button" @click="declineCookies">
                    Decline
                </button>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent } from 'vue';

// Declare gtag function for TypeScript
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export default defineComponent({
  methods: {
    acceptCookies() {
        const ONE_YEAR = 60 * 60 * 24 * 365;
        document.cookie = `cookieConsent=true; path=/; max-age=${ONE_YEAR}; SameSite=Lax`;

        // Switch all five consent types to "granted"
        if (typeof window.gtag === 'function') {
            window.gtag('consent', 'update', {
                ad_storage:         'granted',
                analytics_storage:  'granted',
                ad_user_data:       'granted',
                ad_personalization: 'granted'
            });
        }
        
        this.$emit('close-popup');
    },
    
    declineCookies() {
        const ONE_YEAR = 60 * 60 * 24 * 365;
        document.cookie = `cookieConsent=false; path=/; max-age=${ONE_YEAR}; SameSite=Lax`;
        
        // Keep everything denied (default) - no need to call gtag
        this.$emit('close-popup');
    }
  },
});
</script>

<style scoped>
.cookie__buttons {
  display: flex;
  gap: 12px;
}

@media (max-width: 600px) {
  .cookie__buttons {
    gap: 8px;
  }
}
</style>
